import {BaseRequest} from '@configs/request';
import {authStore} from '@store/stores/auth-store';

export interface IntegrationRequest extends BaseRequest {
  url: string;
  getIntegrations(): Promise<any>;
  patchIntegrations(data: {
    app: string;
    token?: string;
    data?: any;
  }): Promise<any>;
  postIntegrations(data: {app: string; token: string}): Promise<any>;
  deleteIntegrations(app: string): Promise<any>;
}

export class IntegrationRequestImpl
  extends BaseRequest
  implements IntegrationRequest {
  url: string = '/integrations';

  private getAuthorizationHeader() {
    const token = authStore?.auth?.tokens?.access?.token || '';
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }

  async getIntegrations() {
    const {data: response} = await this.request.get(
      `${this.url}`,
      {...this.getAuthorizationHeader(), useCache: false},
    );

    return response;
  }

  async postIntegrations(data: {app: string; token: string}) {
    const {data: response} = await this.request.post(
      `${this.url}/`,
      data,
      this.getAuthorizationHeader(),
    );
    return response;
  }

  async patchIntegrations(data: {app: string; token?: string; data?: any}) {
    const {data: response} = await this.request.patch(
      `${this.url}/`,
      data,
      this.getAuthorizationHeader(),
    );
    return response;
  }

  async editAppIntegrations(data: any, app: string) {
    const {data: response} = await this.request.patch(
      `${this.url}/${app}`,
      {data},
      this.getAuthorizationHeader(),
    );
    return response;
  }

  async getAppReport(app: string) {
    const {data: response} = await this.request.get(
      `${this.url}/${app}/reports`,
      this.getAuthorizationHeader(),
    );
    return response;
  }

  async deleteIntegrations(app: string) {
    const {data: response} = await this.request.delete(
      `${this.url}/${app}`,

      this.getAuthorizationHeader(),
    );
    return response;
  }
}

export const integrationRequest = new IntegrationRequestImpl();
